module.exports = __webpack_public_path__ + "static/media/accessory28.93e6c954.webp";